import { createFileRoute } from '@tanstack/react-router';
import { Project } from '../../organisms/Project';
import { Suspense } from 'react';
import { FullLoader } from '@sc/shared-ui';
// eslint-disable-next-line import/extensions
import { projectsValidateSearch } from './kb_.$uuid';

export const Route = createFileRoute(
  '/_authenticated/kb_/$uuid_/$queryUuid'
)({
  component: RouteComponent,
  validateSearch: projectsValidateSearch,
});

function RouteComponent() {
  const params = Route.useParams();
  const search = Route.useSearch();

  return (
    <Suspense fallback={<FullLoader className="size-8" />}>
      <Project
        showHistory={!!search?.history}
        uuid={params.uuid}
        openModal={search?.modal}
        queryUuid={params.queryUuid}
      />
    </Suspense>
  );
}
